import { cn } from "@/shared/lib/cn";

/* A soft band of light that passes over the placeholder (still when motion is reduced). */
const SHIMMER =
  "animate-shimmer bg-[linear-gradient(90deg,var(--color-surface-sunken)_30%,var(--color-surface-hover)_50%,var(--color-surface-sunken)_70%)] bg-[length:220%_100%]";

/** Where content is about to appear. Size it with className, the way the content will be. */
export function Skeleton({ className }: { className?: string }) {
  return <span aria-hidden="true" className={cn("block rounded-md", SHIMMER, className)} />;
}
